module.exports = __webpack_public_path__ + "assets/img/shijiazhuang.8494292f.png";